 window.st_offers = {
    "moisturiser": "Flat 15% OFF + Free Gifts",
    "sunscreen": "Flat 15% OFF + Free Gifts",
    "serum": "Flat 15% OFF + Free Gifts",
    "face wash": "Flat 15% OFF + Free Gifts",
    "lip balm": "Flat 15% OFF + Free Gifts",
    "mask": "Flat 15% OFF + Free Gifts",
    "eye care": "Flat 15% OFF + Free Gifts",
    "toner": "Flat 15% OFF + Free Gifts",
    "bodycare": "Flat 15% OFF + Free Gifts",
    "haircare": "Flat 15% OFF + Free Gifts",
    "combo": "Flat 25% OFF",
    "merch": "Flat 15% OFF + Free Gifts",
    "lip": "Flat 15% OFF + Free Gifts",
};